import { Box } from '@chakra-ui/react';

export function FormRowActions({ children }: { children?: React.ReactNode }) {
  return <Box>{children}</Box>;
}
